module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "set-title-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "SetTitle__container"
  }, [_c('div', {
    staticClass: "SetTitle__title"
  }, [_vm._v("\n      Add title to conference\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "SetTitle__form"
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label uppercase"
  }, [_vm._v("\n          title\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('title')
    },
    attrs: {
      "type": "text",
      "name": "title",
      "placeholder": "Enter title here",
      "data-vv-delay": "500",
      "data-vv-as": "TITLE",
      "data-vv-name": "title",
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b49772f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/set-title.modal/set-title.modal.vue
// module id = 433
// module chunks = 1